export const launchTimeMap = {
    us: '2023/06/30 15:00:00 GMT+8',
    ca: '2023/06/30 15:00:00 GMT+8',
    eu: '2023/06/30 15:00:00 GMT+8',
    uk: '2023/06/30 15:00:00 GMT+8',
    au: '2023/06/30 15:00:00 GMT+8',
    za: '2023/06/30 15:00:00 GMT+8',
    de: '2023/07/06 15:00:00 GMT+8',
    fr: '2023/07/06 15:00:00 GMT+8',
    es: '2023/07/06 15:00:00 GMT+8',
    it: '2023/07/06 15:00:00 GMT+8',
};

export const seoConfig = {
    url: 'community',
    locales: ['us', 'ca', 'eu', 'uk', 'au', 'za', 'de', 'fr', 'it', 'es'],
};
